module.exports = __webpack_public_path__ + "77b999a696e30608b403ec3bd365ca7a.svg";